module.exports = __webpack_public_path__ + "img/permissions.171e547c.svg";